import { useEffect } from 'react'

// 最大リダイレクト回数
const MAX_REDIRECTS = 3
const REDIRECT_COUNT_KEY = 'localhostRedirectCount'

/**
 * 開発環境でlocalhostアクセス時に127.0.0.1へ自動リダイレクトするフック
 * サーバサイドのCSRF_TRUSTED_ORIGINS設定に合わせるため
 */
export const useLocalhostRedirect = () => {
  useEffect(() => {
    const currentHost = window.location.hostname
    const isLocalhost = currentHost === 'localhost'

    // localhost でアクセスされた場合、127.0.0.1 にリダイレクト
    if (isLocalhost) {
      // リダイレクト回数を取得
      const redirectCount = parseInt(
        sessionStorage.getItem(REDIRECT_COUNT_KEY) || '0'
      )

      // リダイレクト回数が上限を超えている場合は実行しない
      if (redirectCount >= MAX_REDIRECTS) {
        console.error(
          `Redirect limit reached (${MAX_REDIRECTS}). Stopping redirect to prevent infinite loop.`
        )
        // リダイレクトカウントをリセット
        sessionStorage.removeItem(REDIRECT_COUNT_KEY)
        return
      }

      const currentUrl = window.location.href
      const redirectUrl = currentUrl.replace('localhost', '127.0.0.1')

      // リダイレクト回数を増やす
      sessionStorage.setItem(REDIRECT_COUNT_KEY, String(redirectCount + 1))

      // localhostから127.0.0.1へのリダイレクトを実行
      window.location.replace(redirectUrl)
    } else {
      // localhost以外の場合はカウントをリセット
      sessionStorage.removeItem(REDIRECT_COUNT_KEY)
    }
  }, [])
}

/**
 * URLがlocalhostを含むかどうかをチェックする関数
 */
export const isLocalhostUrl = (url: string): boolean => {
  try {
    const urlObj = new URL(url)
    return urlObj.hostname === 'localhost'
  } catch {
    return false
  }
}

/**
 * localhostのURLを127.0.0.1に変換する関数
 */
export const convertLocalhostTo127 = (url: string): string => {
  if (isLocalhostUrl(url)) {
    return url.replace('localhost', '127.0.0.1')
  }
  return url
}
